<div class="bg-warning text-primary section-intro" *transloco="let t">
  <div class="container py-4">
    <div class="row">
      <div class="col-12">
        <h1>
          {{ t('guest.about.intro.title') }}
          <div class="volant">
            <img class="w-100" src="/img/volant.svg" alt="Volant illustration - hopla" height="67" width="76"/>
          </div>
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h2 class="mt-5">{{ t('guest.about.intro.subtitle') }}</h2>
      </div>
      <div class="col-12">
        <h3 class="my-1">{{ t('guest.about.intro.intro') }}</h3>
        <p>
          <a appScrollTo="section-about" class="btn btn-info text-uppercase fw-bold mx-1 my-1">{{ t('guest.about.intro.btnLearnMore') }}</a>
          <a appScrollTo="section-host" class="btn btn-danger text-uppercase fw-bold mx-1 my-1">{{ t('guest.about.intro.btnHost') }}</a>
        </p>
      </div>
    </div>
  </div>
  <section appScrollTarget="section-about" class="section-about h-pad v-pad">
    <div class="about-grid">
      <div class="about-content">
        <h2>{{ t('guest.about.about.title') }}</h2>
        <p class="my-2">{{ t('guest.about.about.intro') }}</p>
      </div>
      <div class="text-center">
        <a [routerLink]="routes.dashboard" class="btn btn-primary text-uppercase fw-bold mx-1 my-1">{{ t('guest.about.about.btnSearch') }}</a>
      </div>
      <div class="about-items">
        <div class="about-item">
          <div class="about-item-img">
            <img src="/img/about-items/diversity.svg" alt="Diversity" width="120"/>
          </div>
          <div class="about-item-text">
            <p>{{ t('guest.about.about.filters.diversity') }}</p>
          </div>
        </div>
        <div class="about-item">
          <div class="about-item-img">
            <img src="/img/about-items/accessibility.svg" alt="Accessibility" width="100"/>
          </div>
          <div class="about-item-text">
            <p>{{ t('guest.about.about.filters.accessibility') }}</p>
          </div>
        </div>
        <div class="about-item">
          <div class="about-item-img">
            <img src="/img/about-items/filter.svg" alt="Filter" width="120"/>
          </div>
          <div class="about-item-text">
            <p>{{ t('guest.about.about.filters.filters') }}</p>
          </div>
        </div>
        <div class="about-item">
          <div class="about-item-img">
            <img src="/img/about-items/social.svg" alt="Socialize" width="120"/>
          </div>
          <div class="about-item-text">
            <p>{{ t('guest.about.about.filters.social') }}</p>
          </div>
        </div>
        <div class="about-item">
          <div class="about-item-img">
            <img src="/img/about-items/discover.svg" alt="Discover" width="88"/>
          </div>
          <div class="about-item-text">
            <p>{{ t('guest.about.about.filters.discover') }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section appScrollTarget="section-host" class="section-host">
    <div class="section-container">
      <div class="activity-title">
        <h2 class="fg-yellow">
          {{ t('guest.about.host.title') }}

          <br/>
          {{ t('guest.about.host.title2') }}
        </h2>
        <div class="activity-title-img">
          <img src="/img/trumpet.svg" alt="Illustration de trompette - hopla" width="98"/>
        </div>
      </div>
      <div class="activity-grid my-2">
        <p>{{ t('guest.about.host.p1') }}</p>
<!--        <p>{{ t('guest.about.host.p2') }}</p>-->
      </div>
      <div class="text-center">
        <a [routerLink]="routes.publish" class="btn btn-warning text-uppercase fw-bold mx-1 my-1">{{ t('guest.about.host.btnPublish') }}</a>
      </div>
    </div>
  </section>
</div>
